import {useContext} from 'react';

import {BaseVehicle} from '../../core/types/BaseVehicle';
import {VehicleFormContext, VehicleFormContextValue} from '../VehicleFormContext';

/**
 * Hook to access vehicle form context
 * Provides form control, XState machine, and utilities to child components
 */
export function useVehicleFormContext<
  T extends BaseVehicle = BaseVehicle,
>(): VehicleFormContextValue<T> {
  const context = useContext(VehicleFormContext);

  if (!context) {
    throw new Error('useVehicleFormContext must be used within VehicleFormProvider');
  }

  return context as VehicleFormContextValue<T>;
}
